import {type VFC} from 'react';
import {
  type LazyLoadImageProps,
  LazyLoadImage,
} from 'react-lazy-load-image-component';

type ReactImageLazyLoadProps = {
  imageSrc?: string;
} & LazyLoadImageProps;

const ReactImageLazyLoad: VFC<ReactImageLazyLoadProps> = ({
  imageSrc,
  alt = 'img',
}) => (
  <LazyLoadImage
    alt={alt}
    placeholderSrc={imageSrc}
    src={imageSrc}
    visibleByDefault={true}
  />
);

export default ReactImageLazyLoad;
